export enum ValidatorType {
  Global = 1,
  ProductDocument = 2,
  GroupHRSubmission = 3,
  GroupClaimSubmission = 4,
  GroupClaimApprove = 5,
  DocumentType = 6,
  ClaimType = 7,
  InvstQueueRptSummary = 8,
}

export enum ClaimType {
  Group = 'Group',
  Individual = 'Individual',
  Bancassurance = 'Bancassurance'
}

export enum ClaimTypePrefixNumber {
  IL ='IL',
  ID = 'ID',
  GM = 'GM',

  GL = 'GL',
  BL = 'BL',
  BM = 'BM'

}

// export enum ClaimEntryStatus {
//   InProgress = 1,
//   DoneDocumentEntry = 2,
//   SendToMedicalQueue = 3,
// }

export enum FacilityType {
  Inclusion = 1,
  Exlcusion = 2,
}

export enum BancaPatientCategory {
  Enrol = 0,
  EnrolDependent = 1,
}

export const productCodes = {
  IP: '045',
  ExtendedIP: '345',
  OutPatient_OP: '145',
  OutPatient_Per_Disability: '146',
  AMR: '335',
  Optical: '080',
  Dental: '090',
  Maternity: '049',
  IP_YEARLY: '445',
  IP_FIELD_FORCE: '046',
  IP_YEARLY_WITHOUT_MATERNITY : "446"
};

export const maternityBenefits = {
  LegalAbortion: { id: 1, benefitId: 14, code: 'B0012' },
  NormalDelivery: { id: 2, benefitId: 5, code: 'B0004' },
  CesarianSection: { id: 3, benefitId: 8, code: 'B0006' },
  WillfulTermination: { id: 4 },
};

export enum GroupPolicyType
{
    Group = 1,
    Bancassurance = 2
}

export enum BundleClaimStatus
{
    Decline = 0,
    Initial = 1,
    InProgress = 2,
    DataEntryDone = 3,
    Reverted = 4,
    SendToMedicalQueue = 5,
    SendToNIGOAdjudicationQueue = 6,
    SendToManualAdjudicationQueue = 7,
    SendToNIGOPaymentQueue = 8,
    SendToPaymentQueue = 9,
    SendToInvestigationQueue = 10,
    SendToBCC2Queue = 11,
    SendToBCC3Queue = 12,
    SendToPreEligibilityQueue = 13,
    SendToPartialPaymentQueue = 14,
    SendToMibWpHoldingQueue = 15,
    SendToOtherDepartementQueue = 16,
    SendIndividualHoldingQueue = 17,
    SendToIndividualCorrectionQueue = 18,
    SendToBancaQueue = 19,
    SendToNigoBancaQueue = 20,
    SendToBancaCorrectionQueue = 21,
}

export enum ClaimEntryStatus
{
    Decline = 0,
    InProgress = 1,
    DoneDocumentEntry = 2, //this Status is only used for tracking done user activity in ApplicationQueueHistoryLogs
    SendToMedicalQueue = 3,
    EligibilityFailed = 4,
    SendToNIGOAdjudicationQueue = 5,
    SendToManualAdjudicationQueue = 6,
    SendToNIGOPaymentQueue = 7,
    SendToPaymentQueue = 8,
    RevertedToDataEntry = 9,
    DeclineBySystem = 10,
    MaternityHoldingQueue = 11,
    PPOHoldingQueue = 12,
    GLHoldingQueue = 20,
    SendToNIGOMedicalAdvisorQueue = 21,
    SendToOtherDepartmentQueue = 24,

    SendToInvestigationQueue = 23,
    SendToNigoPartialPaymentQueue = 26,

    //Ind & Banca
    WaitingForBenefitCalculation = 15,
    AdjudicationApprove = 16,
    AdjudicationDecline = 17,
    WaitingForAdjudication = 22,
    SendToNigoBancaQueue = 25,


    // individual
    SendToPolicyAdminQueue = 13,
    WaitingForNigo = 14,
    SendToPartialPaymentQueue = 18,
    MibWPHoldingQueue = 19
}

export enum ClaimPayTo
{
    Employer = 1,   
    AssignedProvide = 2,
    Employee = 3,
    Beneficiary = 4,
    Owner = 5,
    Assignee = 6,
}

export enum ResponseMessageStatus {
  Ok = 1,
  MobileNumberNotFound = 2,
  OtpValidationFailed = 3,
  OtpTryLimitExceeded = 4,
}

export enum PPORequestStatus {
  Initialized = 1,
  Approved = 2,
  Rejected = 3,
  Submitted = 4,
  Cancelled = 5
}

export enum LatestClaimStatus{
  Declined = 1,
  Pending = 2,
  Completed = 3
}

export enum AnniversaryType{
  CurrentAnniversary = 1,
  LastAnniversary = 2,
  OthersAnniversary = 3,
}

export enum LoginType{
  Enrol = 1,
  Others = 2
}

export enum EbDashboardLatestClaimStatus{
  Declined = 1,
  Pending = 2,
  Paid = 3
}

export enum EbDashboardEmailType{
  MemberAndBenefitDetails = 1,
  LifeCard = 2,
  MedicalCard = 3,
  ClaimUsage = 4
}

export enum EbHrDashboardEmailType{
  LifeAndDisabilityClaimStatus = 1,
  GroupMedicalClaimStatus = 2,
  AllClaimReport = 3
}